module.exports = __webpack_public_path__ + "img/调研报告_03.9b1d4206.svg";